const scrollPositionsKey = "scrollPositions";

function forgetScrollPosition(url: string) {
    try {
        const { pathname } = new URL(url, window.location.origin);

        // Same-pathname pushes only change the query string, such as picking a configurator swatch on
        // a PDP, and must keep the visitor where they are.
        if (pathname === window.location.pathname) {
            return;
        }

        const scrollPositions = JSON.parse(sessionStorage.getItem(scrollPositionsKey) || "{}");
        if (scrollPositions[pathname]) {
            delete scrollPositions[pathname];
            sessionStorage.setItem(scrollPositionsKey, JSON.stringify(scrollPositions));
        }
    } catch {
        // Unreadable storage or URL just means the router keeps its own behaviour.
    }
}

/**
 * SpireRouter retains scroll positions in sessionStorage keyed by pathname and replays them on every
 * navigation, so following a link to a page visited earlier drops the visitor back where they left it
 * instead of at the top. Browser back and forward never call pushState, so discarding the stored
 * position here limits scroll restoration to actual history navigation.
 */
export default function limitScrollRestorationToHistoryNavigation() {
    if (typeof window === "undefined" || (window.history as any).surScrollRestorationPatched) {
        return;
    }

    (window.history as any).surScrollRestorationPatched = true;

    const originalPushState = window.history.pushState.bind(window.history);
    window.history.pushState = (data: any, unused: string, url?: string | URL | null) => {
        if (url) {
            forgetScrollPosition(String(url));
        }

        return originalPushState(data, unused, url);
    };
}
